module.exports = __webpack_public_path__ + "img/logo-4-light.6c66b230.png";